import { tv } from '@/ui/utils'

/**
 * The brand's field: square, white, a grey hairline, 44px tall. Focus turns the hairline Digital
 * Blue; an error turns it red and adds a red helper line beneath; disabled fills it grey. The
 * border is always present so the box never shifts by a pixel between states.
 */
export const inputStyles = tv({
	slots: {
		container: 'w-full bg-transparent',
		input:
			'outline-none min-h-[52px] w-full rounded-brand border border-edge bg-white px-4 py-0 font-body-medium text-[16px] text-ink focus:border-focus box-border placeholder:text-muted placeholder:opacity-100',
		placeholder: 'font-body',
		// Set in from the field's edge rather than under its corner: the box is rounded, so a line
		// flush with its left sits under the curve and reads as unaligned with everything above it.
		// The inset is the field's own, so the message starts where the typing does.
		error: 'mt-1 px-4 font-body text-body2 text-danger',
	},
	variants: {
		editable: {
			false: {
				input: 'bg-surface text-muted web:cursor-not-allowed',
			},
		},
		invalid: {
			true: {
				input: 'border-danger focus:border-danger',
			},
		},
	},
})
